
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-name-info",
      function () {
        return require("private-next-pages/legal-name-info.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-name-info"])
      });
    }
  